import script from "./lista-empresas.vue?vue&type=script&setup=true&lang=js"
export * from "./lista-empresas.vue?vue&type=script&setup=true&lang=js"

import "./lista-empresas.vue?vue&type=style&index=0&id=c099804a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c099804a"]])

export default __exports__